"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var logger_1 = require("../../utils/logger");
function getClassName(className) {
    return (className ? className + " " : '') + "linkblock dark-links clickable";
}
// TODO: Check if we can use noreferrer on the links
/* eslint-disable react/jsx-no-target-blank */
var Link = React.forwardRef(function Button(_a, ref) {
    var adObj = _a.adObj, native = _a.adObj.native, className = _a.className, style = _a.style, additionalEventContext = _a.additionalEventContext, dangerouslySetInnerHTML = _a.dangerouslySetInnerHTML, children = _a.children;
    return (React.createElement("a", { ref: ref, href: native.clickUrl, className: getClassName(className), style: style, dangerouslySetInnerHTML: dangerouslySetInnerHTML, target: "_blank", rel: "noopener", onClick: function () {
            logger_1.logClick(adObj.targetId, adObj, additionalEventContext);
        } }, children));
});
/* eslint-enable react/jsx-no-target-blank */
exports.default = Link;
